<template>
    <footer class="footer-main" role="contentinfo">
        <div class="main-nav">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <nav class="navbar navbar-expand-lg navbar-light footer-nav" role="navigation" aria-label="footer-nav">
                <ul class="navbar-nav mr-auto">
                    <li class="footer-list">
                      <a class="nav-link " href="mailto:lexin@oslomet.no" target="_blank">{{ $t('message.contact-us') }}</a>
                    </li>
                    <li class="footer-list" @click="droplist=$t('message.about')">
                     <div><a class="nav-link" href="https://nafo.oslomet.no/ " target="_blank">{{ $t('message.redaktør') }}: {{ $t('message.nafo') }}</a></div>
                    </li>
                    <li class="footer-list" @click="droplist=$t('message.about')">
                      <a class="nav-link" href="https://www.oslomet.no/"  target="_blank">{{ $t('message.oslomet') }}</a>
                    </li>
                    <li class="footer-list">
                        <router-link
                            tag="a"
                            class="nav-link"
                            :lang = selectedLanguageCode
                            :to="{ name: 'PrivacyStatementComponent'}"
                        >{{ $t('message.privacy-statement') }}</router-link>
                    </li>
                    <li class="footer-list">
                        <router-link
                            tag="a"
                            class="nav-link"
                            :lang = selectedLanguageCode
                            :to="{ name: 'AccessibilityStatementComponent'}"
                        >{{ $t('message.accessibility-statement') }}</router-link>
                    </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
        </div>
    </footer>  
</template>
<script>
export default {
  name: "FooterView",
   data() {
     return {
      languageCodeList: [
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  mounted(){
		this.footerAlign();

		$( window ).resize(()=>{
			this.footerAlign();
		});
  },
  computed: {
    selectedLanguageCode () {
        return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  methods:{
		footerAlign(){
			$('footer').css('display', 'block');
			$('footer').css('height', 'auto');
			var footerHeight = $('footer').outerHeight();
			// $('body').css('padding-bottom', footerHeight);
      $('.content-main').css('min-height', 'calc(100vh - 85.2px - '+ footerHeight +'px)');
			$('footer').css('height', footerHeight);
		}
	}
};
</script>

